import { API_HOST } from '@/utils/constants/api';

const absoluteLink = (url, isFileRepositoryLink = false) => {
  if (url.indexOf('://') > 0 || url.indexOf('//') === 0) {
    return url;
  } else {
    return `${API_HOST}${isFileRepositoryLink ? '/files/' : '/api/v1'}${url}`;
  }
};

export default absoluteLink;
